import { useState, forwardRef, useRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, isFunction } from 'lodash';
import Icon from "../../../Icon/Icon";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Search = /*#__PURE__*/forwardRef((props, ref) => {
  const [value, setValue] = useState('');
  const searchRef = useRef(null);
  const onChange = event => {
    setValue(event.target.value);
    if (isFunction(props.onChange)) {
      props.onChange(event.target.value);
    }
  };
  const resetValue = () => {
    setValue('');
    if (isFunction(props.onChange)) {
      props.onChange('');
    }
  };
  useImperativeHandle(ref, () => ({
    onChange(e) {
      onChange(e);
    },
    resetValue() {
      resetValue();
    }
  }), []);
  return /*#__PURE__*/_jsxs("div", {
    className: "relative leading-none",
    children: [/*#__PURE__*/_jsx("label", {
      htmlFor: props.id,
      className: "absolute w-px h-px p-0 m-[-1px] overflow-hidden border-0",
      ref: searchRef,
      children: props.label
    }), /*#__PURE__*/_jsx("input", {
      id: props.id,
      className: "bg-light-border-grey border-solid rounded-t border-b border-t border-light-border-blue block m-0 p-2.5 relative w-full placeholder-placeholder-blue text-sm text-text-blue font-arial-font focus:outline-none",
      type: "text",
      onChange: onChange,
      value: value,
      placeholder: props.placeholder
    }), /*#__PURE__*/_jsx("div", {
      className: "absolute right-4 top-4 transform -translate-y-1/2 outline-none mt-0.5",
      children: isEmpty(value) ? /*#__PURE__*/_jsx(Icon, {
        icon: "Search",
        size: 12,
        color: "medium-grey"
      }) : /*#__PURE__*/_jsx(Icon, {
        icon: "Cross",
        size: 12,
        color: "medium-grey",
        onClick: resetValue
      })
    })]
  });
});
Search.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired
};
export default Search;
//# sourceMappingURL=Search.js.map